export const EClientStatus = {
    /**
     * 토큰 사용 불가능한 상태
     *
     * - 네트워크 에러
     * - 유효하지 않은 토큰
     * - 토큰 존재하지 않음
     */
    Disabled: "disabled",
    /**
     * 토큰 활성화 상태
     */
    Active: "active",
    /**
     * 토큰 비활성화 상태
     */
    Inactive: "inactive",
};
//# sourceMappingURL=EClientStatus.js.map